<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_410_32613)">
      <rect width="71" height="52" fill="white" />
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.5121 5.05556C57.9126 5.05556 59.0478 3.92383 59.0478 2.52778C59.0478 1.13172 57.9126 0 56.5121 0C55.1117 0 53.9764 1.13172 53.9764 2.52778C53.9764 3.92383 55.1117 5.05556 56.5121 5.05556ZM34.7774 48.0278C47.1813 48.0278 57.2366 38.0039 57.2366 25.6389C57.2366 13.2738 47.1813 3.25 34.7774 3.25C22.3736 3.25 12.3182 13.2738 12.3182 25.6389C12.3182 38.0039 22.3736 48.0278 34.7774 48.0278ZM71.0019 20.0417C71.0019 22.5346 68.9746 24.5556 66.4739 24.5556C63.9731 24.5556 61.9458 22.5346 61.9458 20.0417C61.9458 17.5487 63.9731 15.5278 66.4739 15.5278C68.9746 15.5278 71.0019 17.5487 71.0019 20.0417ZM13.2239 49.4722C14.1241 49.4722 14.854 48.7447 14.854 47.8472C14.854 46.9498 14.1241 46.2222 13.2239 46.2222C12.3236 46.2222 11.5938 46.9498 11.5938 47.8472C11.5938 48.7447 12.3236 49.4722 13.2239 49.4722Z"
        fill="url(#paint0_radial_410_32613)"
      />
      <path
        d="M9.4375 25.0215L41.5057 28.7127V34.3914L9.4375 30.7468V25.0215Z"
        fill="url(#paint1_radial_410_32613)"
      />
      <path
        d="M41.5078 28.6481L60.3064 18.6816V24.3768L41.5078 34.39V28.6481Z"
        fill="url(#paint2_radial_410_32613)"
      />
      <path
        d="M28.07 14.8242L60.3043 18.6228L41.4436 28.879L9.4375 25.0209L28.07 14.8242Z"
        fill="url(#paint3_radial_410_32613)"
      />
      <path
        d="M41.6578 33.2211L27.168 27.4434L41.6578 29.5374V33.2211Z"
        fill="url(#paint4_linear_410_32613)"
      />
      <path
        d="M41.5802 29.326L41.2956 34.3047L49.8342 29.8792L57.2344 21.3047L41.5802 29.326Z"
        fill="url(#paint5_linear_410_32613)"
      />
      <path
        d="M28.053 13.7227L60.8567 19.8086L41.4283 29.9727L9.41797 23.8868L28.053 13.7227Z"
        fill="url(#paint6_radial_410_32613)"
      />
      <path
        d="M32.2412 16.6107C32.2412 17.209 30.9438 17.694 29.3433 17.694C27.7428 17.694 26.4453 17.209 26.4453 16.6107C26.4453 16.0124 27.7428 15.5273 29.3433 15.5273C30.9438 15.5273 32.2412 16.0124 32.2412 16.6107Z"
        fill="url(#paint7_radial_410_32613)"
      />
      <path
        d="M9.48122 27.084L33.3269 29.9729L8.33203 27.6092L9.48122 27.084Z"
        fill="url(#paint8_radial_410_32613)"
      />
      <path
        d="M9.34954 29.25L21.7333 30.6944L9.05469 29.5389L9.34954 29.25Z"
        fill="url(#paint9_radial_410_32613)"
      />
      <path
        d="M60.3022 20.9453L50.7126 26.0009L60.8555 21.1398L60.3022 20.9453Z"
        fill="url(#paint10_radial_410_32613)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.1606 17.5156C40.4309 17.5416 40.5078 17.8965 40.2721 18.0303L26.9903 25.5702C26.9387 25.5995 26.879 25.6117 26.82 25.6049L25.1011 25.4092C24.8344 25.3789 24.761 25.0288 24.9935 24.8956L38.1191 17.3711C38.1694 17.3422 38.2276 17.3297 38.2855 17.3353L40.1606 17.5156ZM56.9993 19.9844C57.2655 20.0255 57.3237 20.3801 57.0843 20.5028L41.4864 28.4976C41.431 28.5259 41.3677 28.5351 41.3065 28.5236L28.9028 26.1934C28.6489 26.1457 28.5915 25.8107 28.8154 25.6826L42.5698 17.8149C42.6249 17.7834 42.6892 17.7715 42.752 17.7812L56.9993 19.9844ZM29.883 20.6673C30.1064 20.5379 30.0468 20.2028 29.7923 20.1569L27.9862 19.8313C27.9216 19.8197 27.855 19.831 27.7981 19.8632L20.789 23.8343C20.5587 23.9649 20.6252 24.3105 20.8879 24.3477L22.9137 24.6347C22.9759 24.6435 23.0393 24.6312 23.0936 24.5997L29.883 20.6673Z"
        fill="url(#paint11_radial_410_32613)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5965 18.7297C17.6615 18.984 17.8756 19.3148 18.3785 19.661C18.7197 19.8958 19.4142 20.2624 20.1312 20.6252C20.4377 20.7803 20.7477 20.9344 21.0296 21.0746C21.3954 21.2564 21.714 21.4148 21.9169 21.5216C22.026 21.5791 22.121 21.5718 22.2116 21.5259C22.3122 21.4749 22.4131 21.3705 22.4841 21.2315C22.5549 21.0926 22.5822 20.9458 22.5663 20.829C22.5515 20.7209 22.5024 20.6428 22.4087 20.5934L20.1457 19.4021C20.0624 19.3582 20.0094 19.3629 19.9836 19.3703C19.9552 19.3784 19.9332 19.3972 19.92 19.422C19.9069 19.4469 19.9038 19.4756 19.913 19.5035C19.9214 19.529 19.9474 19.5752 20.0307 19.6191L21.7662 20.5327C21.9012 20.6038 21.9529 20.7705 21.8816 20.9051C21.8103 21.0397 21.643 21.0912 21.508 21.0201L19.7725 20.1064C19.5808 20.0055 19.4471 19.855 19.3879 19.676C19.3295 19.4995 19.351 19.3159 19.4311 19.1646C19.5112 19.0134 19.6512 18.8922 19.8304 18.8407C20.0121 18.7885 20.2121 18.8137 20.4039 18.9147L22.6669 20.1061C22.9407 20.2502 23.0789 20.497 23.1141 20.7547C23.1482 21.0037 23.0881 21.2634 22.9769 21.4813C22.8658 21.6991 22.69 21.9017 22.4622 22.0172C22.2243 22.1378 21.939 22.1566 21.6587 22.009C21.4595 21.9041 21.1521 21.7514 20.7938 21.5733C20.5118 21.4331 20.1983 21.2773 19.8809 21.1167C19.1734 20.7587 18.4424 20.3748 18.0643 20.1145C17.4926 19.721 17.1693 19.2904 17.0607 18.8659C16.9505 18.435 17.0709 18.041 17.3241 17.7687C17.5731 17.5009 17.9453 17.3565 18.3282 17.4022C18.7183 17.4488 19.0908 17.688 19.3515 18.1312L19.4914 18.3689L19.0144 18.6478L18.8746 18.41C18.6895 18.0953 18.459 17.9729 18.2625 17.9494C18.0588 17.9251 17.8608 18.0023 17.7296 18.1434C17.6027 18.2799 17.5331 18.4819 17.5965 18.7297Z"
        fill="url(#paint12_radial_410_32613)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(56.9823 -8.94247) rotate(116.884) scale(71.2059 74.0383)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.847 34.3914) rotate(-159.529) scale(35.8529 12.6366)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#F5F6FB" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.3569 25.739) rotate(20.7366) scale(26.3617 23.6325)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.7255 31.5143) rotate(-97.2013) scale(39.4127 42.3323)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_410_32613"
        x1="46.134"
        y1="48.4824"
        x2="48.8127"
        y2="25.1411"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.510414" stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#A3B1D1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_410_32613"
        x1="33.1888"
        y1="45.8151"
        x2="37.4968"
        y2="17.4996"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.510414" stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#A3B1D1" />
      </linearGradient>
      <radialGradient
        id="paint6_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(73.3592 33.8017) rotate(-162.414) scale(67.076 43.0967)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.2412 16.9492) rotate(-180) scale(16.0595 6.00347)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.5101 46.9451) rotate(-56.5626) scale(35.0514 40.9604)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.8285 29.25) rotate(-26.4347) scale(36.989 37.6636)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.9412 24.4453) rotate(-150.851) scale(36.4074 39.5604)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.0646 22.2635) rotate(8.10907) scale(47.6398 18.0109)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_410_32613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.7377 18.0593) rotate(34.3529) scale(22.7081 7.10261)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <clipPath id="clip0_410_32613">
        <rect width="71" height="52" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
